import { connect } from 'react-redux';

import * as tracking from './tracking';
import { getDateRangeValue } from '../../../../packages/JsonQuery';
import { closeChatModal } from '../../actions/chatModal';
import { IChatModalProps, ChatModal } from '../../components/ChatModal';
import { selectJsonQuery } from '../../selectors/filters';
import { selectOfferById } from '../../selectors/listingOffers';
import { IApplicationState, TThunkDispatch } from '../../types/redux';

type TChatModalStateProps = Pick<IChatModalProps, 'gaLabel' | 'offer' | 'isOpen' | 'dates' | 'defaultMessage'>;
type TChatModalDispatchProps = Required<Pick<IChatModalProps, 'onClose'>>;
type TChatModalOwnProps = Omit<IChatModalProps, keyof TChatModalStateProps | keyof TChatModalDispatchProps>;

export function mapStateToProps(state: IApplicationState): TChatModalStateProps {
  const jsonQuery = selectJsonQuery(state);
  const offer = selectOfferById(state, state.chatModal.offerId);
  let dates = null;

  const { gaLabel, isOpen, defaultMessage } = state.chatModal;

  try {
    const range = jsonQuery ? getDateRangeValue('dates')(jsonQuery) : null;
    dates = range ? { checkin: range.gte, checkout: range.lt } : null;
    // eslint-disable-next-line no-empty
  } catch (e) {}

  return { gaLabel, isOpen, defaultMessage, offer, dates };
}

export function mapDispatchToProps(dispatch: TThunkDispatch): TChatModalDispatchProps {
  return {
    onClose: () => dispatch(closeChatModal()),
  };
}

export function mergeProps(
  stateProps: TChatModalStateProps,
  dispatchProps: TChatModalDispatchProps,
  ownProps: TChatModalOwnProps,
): IChatModalProps {
  const onOpen = () => tracking.trackModalOpen(stateProps.gaLabel);

  return {
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    onOpen,
  };
}

export const ChatModalContainer = connect(mapStateToProps, mapDispatchToProps, mergeProps)(ChatModal);
